import React from 'react';
import PropTypes from 'prop-types';

import { Field } from 'formik';
import TextArea from 'components/text-area';

const FieldTextArea = ({ className, type, ...rest }) => {
  return (
    <Field {...rest} type={type}>
      {({ field }) => (
        <TextArea type={type} className={className} {...rest} {...field} />
      )}
    </Field>
  );
};

FieldTextArea.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
};

FieldTextArea.defaultProps = {
  type: 'text',
  className: null,
};

export default FieldTextArea;
